import req from './request'

const DEFAULT_ENDPOINTS = {
    aggregators: '/wolt/aggregators',
    auth: '/wolt/aggregators/auth',
    couriers: '/wolt/couriers',
    transactions: '/wolt/transactions',
    reference: '/wolt/transactions/reference',
    workRules: '/wolt/work-rules',
    workRulesReference: '/wolt/work-rules/reference',
    incomesList: '/wolt/incomes/list',
    metrics: '/wolt/metrics',
    courierAgreement: '/wolt/courier-agreement',
    incomeshistory: '/wolt/incomes/history',
    sendEmail: '/wolt/aggregators/send-email',
    couriersAgreementsList: '/wolt/couriers-agreements/list',
    couriersAgreementsArchive: '/wolt/couriers-agreements/make-archive',
    couriersAgreementsPreAuth: '/wolt/couriers-agreements/pre-auth',
    couriersAgreementsPushToSign: '/wolt/couriers-agreements/push-to-sign',
    signUp: '/wolt/sign-up',
    couriersReference: '/wolt/couriers/reference',
    signUpDocuments: '/wolt/sign-up/documents',
    externalDocuments: '/wolt/external-documents',
    assignFile: '/wolt/sign-up/assign-file',
    takeIntoWork: '/wolt/sign-up/take-into-work',
    couriers: '/wolt/couriers',
    completeTheCandidate: '/wolt/sign-up/complete-the-candidate',
    sendingToError: '/wolt/sign-up/sending-to-error',
    onboard: '/wolt/onboard',

    heldBonusesActive: '/wolt/held-bonuses/active',
    heldBonusesHistory: '/wolt/held-bonuses/history',
    heldBonusesRefund: '/wolt/held-bonuses/refund',
    orders: '/wolt/orders'
}

export default {
    aggregators(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.aggregators, param)
    },
    auth(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.auth, param)
    },
    couriers(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.couriers, param)
    },
    transactions(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.transactions, param)
    },
    reference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reference, param)
    },
    workRules(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.workRules, param)
    },
    workRulesReference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.workRulesReference, param)
    },
    incomesList(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.incomesList, param)
    },
    metrics(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.metrics, param)
    },
    courierAgreement(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.courierAgreement, param)
    },
    incomeshistory(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.incomeshistory, param)
    },
    sendEmail(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.sendEmail, param)
    },
    couriersAgreementsList(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.couriersAgreementsList, param)
    },
    couriersAgreementsArchive(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.couriersAgreementsArchive, param)
    },
    couriersAgreementsPreAuth(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.couriersAgreementsPreAuth, param)
    },
    couriersAgreementsPushToSign(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.couriersAgreementsPushToSign, param)
    },
    signUp(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.signUp, param)
    },
    couriersReference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.couriersReference, param)
    },
    signUpDocuments(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.signUpDocuments, param)
    },
    externalDocuments(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.externalDocuments, param)
    },
    assignFile(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.assignFile, param)
    },
    takeIntoWork(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.takeIntoWork, param)
    },
    couriers(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.couriers, param)
    },
    completeTheCandidate(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.completeTheCandidate, param)
    },
    sendingToError(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.sendingToError, param)
    },
    onboard(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.onboard, param)
    },
    heldBonusesActive(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.heldBonusesActive, param)
    },
    heldBonusesHistory(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.heldBonusesHistory, param)
    },
    heldBonusesRefund(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.heldBonusesRefund, param)
    },
    orders(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.orders, param)
    },

}